import React from "react"
import { string } from "prop-types"
import { SavedBadge } from "components/shared/saved_badge"

const RequestStates = { DONE: 4 }

export default class AutosaveForm extends React.Component {
  static propTypes = {
    __html: string
  }

  state = {
    errors: {},
    savedSuccessfully: false
  }

  componentDidMount() {
    this.form = this.node.getElementsByTagName("form")[0]
    this.inputs = []
      .concat(Array.from(this.form.getElementsByTagName("input")))
      .concat(Array.from(this.form.getElementsByTagName("select")))

    this.form.addEventListener("submit", event => {
      event.preventDefault()
    })

    this.inputs.forEach(input => {
      input.addEventListener("change", this.handleFormSubmit)
    })

    this.setState({ savedSuccessfully: false })
  }

  componentWillUnmount() {
    this.inputs.forEach(input => input.removeEventListener("change"))
    this.form.removeEventListener("submit")
    this.setState({ savedSuccessfully: false })
  }

  handleFormSubmit = () => {
    this.setState({ savedSuccessfully: false })

    const request = new XMLHttpRequest()
    request.open(this.form.method, this.form.action)
    request.responseType = "json"
    request.onreadystatechange = () => {
      if (request.readyState === RequestStates.DONE) {
        if (request.status === 200) {
          this.setState({ savedSuccessfully: true })
        } else {
          this.setState({
            errors: request.response.errors
          })
        }
      }
    }

    request.send(new FormData(this.form))
  }

  render() {
    const { __html } = this.props
    const { savedSuccessfully } = this.state

    return (
      <div ref={el => (this.node = el)} className="p-r">
        <div
          css={{
            position: "absolute",
            zIndex: 1,
            top: 16,
            right: 16,
            pointerEvents: "none"
          }}
        >
          {savedSuccessfully && <SavedBadge />}
        </div>
        <div dangerouslySetInnerHTML={{ __html }} />
      </div>
    )
  }
}
